/* ---------------------------------------------
   Helpers to FIX legacy “stringified array” data.
   Older LoanOfficer records stored some lists (states, groups, ...) as JSON
   text, e.g. ['["Alabama","Georgia"]'] instead of ["Alabama", "Georgia"].
   Mirrors server/utils/stringArray.js.
---------------------------------------------- */
function tryJsonParse(s) {
  if (typeof s !== 'string') return s;
  const t = s.trim();
  if (!t) return s;
  // Only attempt parse when it looks like JSON
  if (!(t.startsWith('[') || t.startsWith('{') || t.startsWith('"'))) return s;
  try {
    return JSON.parse(t);
  } catch {
    return s;
  }
}

// Recursively unwrap arrays that contain JSON-strings of arrays
export function unwrapToStringArray(value) {
  const out = [];

  const walk = (v) => {
    if (v == null) return;

    if (typeof v === 'string') {
      const parsed = tryJsonParse(v);
      if (parsed !== v) walk(parsed);
      else out.push(v);
      return;
    }

    if (Array.isArray(v)) v.forEach(walk);
  };

  walk(value);

  return out
    .map(s => String(s).trim())
    .filter(Boolean);
}

export function uniqueStrings(arr) {
  return Array.from(new Set((arr || []).map(s => String(s).trim()).filter(Boolean)));
}
